import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

import '../styles/Home.css';
import heroImage from '../assets/Home.png';
import img1 from '../assets/img1.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';
import img6 from '../assets/img6.png';


const Home = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 120,
        });
    }, []);
    const location = useLocation();
    const navigate = useNavigate();
    const shownLogoutToast = useRef(false);
    useEffect(() => {
        if (location.state?.logoutSuccess && !shownLogoutToast.current) {
            shownLogoutToast.current = true;
            toast.success("Logout Successful!");
            navigate(location.pathname, { replace: true, state: {} }); 
        }
    }, [location, navigate]);

    return (
        <>
            <Navbar />

            {/* HERO SECTION */}
            <section className="hero">
                <div className="overlay">
                    <div className="hero-content ">
                        <h1 >Your Ultimate Question & Answer <br /> Resource Hub</h1>
                        <img src={heroImage} alt="Hero" className="hero-image" />
                    </div>
                </div>
            </section>



            {/* About */}
            <section className="about-section" data-aos="fade-up">
                <div className="about-container">
                    {/* Text Side */}
                    <div className="about-text">
                        <h2 data-aos="fade-right">Why We’re Your Top Choice</h2>
                        <p data-aos="fade-up">
                            We are redefining the way educators create question papers. Our platform is tailored for schools, tutors, and coaching centers—making paper generation smarter, faster, and 100% customizable.
                        </p>

                        <div className="features-list">
                            <div className="feature" data-aos="fade-right" data-aos-delay="100">
                                <span className="icon">🧠</span>
                                <div>
                                    <h4>Smart Question Bank</h4>
                                    <p>Thousands of curated questions for CBSE, NEET, JEE & state boards.</p>
                                </div>
                            </div>
                            <div className="feature" data-aos="fade-right" data-aos-delay="200">
                                <span className="icon">📚</span>
                                <div>
                                    <h4>Easy Class & Subject Selection</h4>
                                    <p>Select your class and subject quickly from an intuitive dropdown interface.</p>
                                </div>
                            </div>
                            <div className="feature" data-aos="fade-right" data-aos-delay="300">
                                <span className="icon">📄</span>
                                <div>
                                    <h4>Instant PDF Output</h4>
                                    <p>Download your paper in a clean, print-ready PDF format.</p>
                                </div>
                            </div>
                            <div className="feature" data-aos="fade-right" data-aos-delay="400">
                                <span className="icon">🌐</span>
                                <div>
                                    <h4>Multi-Board Support</h4>
                                    <p>Supports national and regional education boards with mapped syllabi.</p>
                                </div>
                            </div>
                        </div>

                        {/* Optional Statistics */}
                        <div className="about-stats" data-aos="fade-up">
                            <div><strong>5,000+</strong><span>Questions Available</span></div>
                            <div><strong>1,000+</strong><span>Papers Generated</span></div>
                            <div><strong>100%</strong><span>Customizable Output</span></div>
                        </div>
                    </div>

                    {/* Right Side: Image */}
                    <div className="about-image">
                        <img src={require('../assets/img15.png')} alt="About" />
                    </div>
                </div>
            </section>

            <section className="about-section" data-aos="fade-up">
                <div className="about-container">

                    {/* Right Side: Image */}
                    <div className="about-image">
                        <img src={require('../assets/img14.png')} alt="Ready Made Papers" />
                    </div>

                    {/* Text Side */}
                    <div className="about-text">
                        <h2 data-aos="fade-right">Get Ready-Made Question Papers Instantly</h2>
                        <p data-aos="fade-up">
                            Save time with pre-designed question papers for all subjects. Perfect for quick assessments, mock exams, and revision tests—just select your class and subject, and download the paper instantly in PDF.
                        </p>

                        <div className="features-list">
                            <div className="feature" data-aos="fade-right" data-aos-delay="100">
                                <span className="icon">📘</span>
                                <div>
                                    <h4>Pre-Made Papers</h4>
                                    <p>Expert-crafted papers for every subject from Grade 6–12, ready for instant use.</p>
                                </div>
                            </div>
                            <div className="feature" data-aos="fade-right" data-aos-delay="200">
                                <span className="icon">🧾</span>
                                <div>
                                    <h4>Structured by Blueprint</h4>
                                    <p>Includes MCQs, short and long answer questions as per latest syllabus and exam format.</p>
                                </div>
                            </div>
                            {/* <div className="feature" data-aos="fade-right" data-aos-delay="300">
                                <span className="icon">⚙️</span>
                                <div>
                                    <h4>Editable & Flexible</h4>
                                    <p>Customize downloaded papers to match your unique teaching style or question format.</p>
                                </div>
                            </div> */}
                            <div className="feature" data-aos="fade-right" data-aos-delay="400">
                                <span className="icon">📤</span>
                                <div>
                                    <h4>One-Click PDF Download</h4>
                                    <p>Instantly get your question paper in a clean, print-ready format.</p>
                                </div>
                            </div>
                        </div>

                        {/* Optional Statistics */}
                        <div className="about-stats" data-aos="fade-up">
                            <div><strong>10,000+</strong><span>Ready-Made Questions</span></div>
                            <div><strong>500+</strong><span>Papers Available</span></div>
                            <div><strong>All Subjects</strong><span>Covered from Grade 6–12</span></div>
                        </div>
                    </div>


                </div>
            </section>


            {/* ➕ Small Image Transition */}
            <div className="transition-image">
                <img src={img3} alt="img3" />
            </div>

            {/* HOW IT WORKS SECTION */}
            <section className="how-it-works" data-aos="fade-up">

                <h5 data-aos="fade-right">How Does It Work</h5>
                <p className="sub-title" data-aos="fade-left">
                    Generate Question Papers in <br></br> Just a Few Steps
                </p>

                <p className="work-description" data-aos="fade-up" data-aos-delay="200">
                    Our platform simplifies the question paper creation process for teachers and educators.
                    Simply select your class and subject, choose questions from our curated bank, and download
                    your customized paper instantly in PDF format. No formatting, no stress—just ready-to-use content.
                </p>


                <div className="steps-container">
                    <div className="step-box" data-aos="fade-up" data-aos-delay="100">
                        <div className="step-number">1</div>
                        <h3>Select Class & Subject</h3>
                        <p>Choose class and subject for which you want to create paper. We have question bank for CBSE, NEET, JEE, and many state boards.</p>
                    </div>

                    <div className="step-image" data-aos="zoom-in" data-aos-delay="200">
                        <img src={img1} alt="img1" />
                    </div>

                    <div className="step-box" data-aos="fade-up" data-aos-delay="300">
                        <div className="step-number">2</div>
                        <h3>Choose Questions</h3>
                        <p>Choose number of questions as per the blueprint you have or customise our preloaded bluepints.</p>
                    </div>

                    <div className="step-image" data-aos="zoom-in" data-aos-delay="400">
                        <img src={img2} alt="img2" />
                    </div>

                    <div className="step-box" data-aos="fade-up" data-aos-delay="500">
                        <div className="step-number">3</div>
                        <h3>Preview & Download Paper</h3>
                        <p>Preview your question paper, make necessary changes and download it as PDF file.</p>
                    </div>
                </div>
            </section>


            {/* Contact Form */}
            <section className="contact-section" data-aos="fade-up">
                <div className="contact-container">
                    {/* Left Side Image */}
                    <div className="contact-image" data-aos="fade-right">
                        <img src={img6} alt="Contact Us" />
                    </div>

                    {/* Right Side Form */}
                    <div className="contact-form" data-aos="fade-left">
                        <h2>Contact Us</h2>
                        <form>
                            <div className="form-group">
                                <label>Name</label>
                                <input type="text" placeholder="Enter your name" required />
                            </div>
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input type="tel" placeholder="Enter your phone number" required />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" placeholder="Enter your email" required />
                            </div>
                            <div className="form-group">
                                <label>Message</label>
                                <textarea placeholder="Your message..." required />
                            </div>
                            <button type="submit" className="send-btn">Send Message</button>
                        </form>
                    </div>
                </div>
            </section>


            <section className="app-download-section" data-aos="fade-up">
                <div className="app-download-container">
                    {/* Left Side - Text and Buttons */}
                    <div className="app-text" data-aos="fade-right">
                        <h2>Download the Android & iOS App</h2>
                        <p>
                            Get instant access to our smart question paper generator anytime, anywhere.
                            Stay connected and productive with our powerful mobile app.
                        </p>
                        <div className="download-buttons">
                            <a href="#" className="download-btn android">
                                <i className="fab fa-google-play"></i>
                                <div>
                                    <span>Get it on</span>
                                    <strong>Google Play</strong>
                                </div>
                            </a>
                            <a href="#" className="download-btn ios">
                                <i className="fab fa-apple"></i>
                                <div>
                                    <span>Download on the</span>
                                    <strong>App Store</strong>
                                </div>
                            </a>
                        </div>
                    </div>

                    {/* Right Side - Image */}
                    <div className="app-image" data-aos="fade-left">
                        <img src={require('../assets/img16.png')} alt="Mobile App" />
                    </div>
                </div>
            </section>

             <Footer />
        </>
    );
};

export default Home;
